export const toIsoBirthDate = (value: string) => {
  const slashMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!slashMatch && !isoMatch) {
    return null;
  }

  const dayString = slashMatch ? slashMatch[1] : (isoMatch as RegExpMatchArray)[3];
  const monthString = slashMatch ? slashMatch[2] : (isoMatch as RegExpMatchArray)[2];
  const yearString = slashMatch ? slashMatch[3] : (isoMatch as RegExpMatchArray)[1];
  const day = Number(dayString);
  const month = Number(monthString);
  const year = Number(yearString);

  const normalizedDate = new Date(Date.UTC(year, month - 1, day));
  const isValidDate =
    normalizedDate.getUTCFullYear() === year &&
    normalizedDate.getUTCMonth() === month - 1 &&
    normalizedDate.getUTCDate() === day;

  if (!isValidDate) {
    return null;
  }

  return `${yearString}-${monthString}-${dayString}`;
};
